/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Onl_How_4_DescInputs */

const en_vc_onl_how_4_desc = /** @type {(inputs: Vc_Onl_How_4_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The online version is updated with each official release. For AI-agent control over MCP and for the command-line tool, use the desktop builds.`)
};

const zh_vc_onl_how_4_desc = /** @type {(inputs: Vc_Onl_How_4_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在线版会跟随每次官方发布更新。如果需要用 MCP 让 AI 助手操控，或使用命令行工具，请下载桌面版。`)
};

/**
* | output |
* | --- |
* | "The online version is updated with each official release. For AI-agent control over MCP and for the command-line tool, use the desktop builds." |
*
* @param {Vc_Onl_How_4_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_onl_how_4_desc = /** @type {((inputs?: Vc_Onl_How_4_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Onl_How_4_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_onl_how_4_desc(inputs)
	return zh_vc_onl_how_4_desc(inputs)
});
export { vc_onl_how_4_desc as "vc.onl.how.4.desc" }